<template>
  <div
    v-if="open"
    aria-live="assertive"
    class="fixed inset-0 flex items-end px-4 py-6 pointer-events-none sm:p-6 sm:items-start z-50"
  >
    <div class="w-full flex flex-col items-center space-y-4 sm:items-end">
      <transition
        enter-active-class="transform ease-out duration-300 transition"
        enter-from-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
        enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"
        leave-active-class="transition ease-in duration-100"
        leave-from-class="opacity-100"
        leave-to-class="opacity-0"
      >
        <div
          v-if="show"
          class="max-w-sm w-full rounded-xl pointer-events-auto overflow-hidden"
          :class="[error ? 'bg-error' : 'bg-bkk-50', this.class]"
        >
          <div class="p-4">
            <div class="flex items-start">
              <div class="flex-shrink-0">
                <slot> </slot>
              </div>
              <div class="ml-3 w-0 flex-1 pt-0.5">
                <p class="text-primary font-bold">{{ title }}</p>
                <p class="mt-1 text-primary">{{ subtitle }}</p>
              </div>
              <div class="ml-4 flex-shrink-0 flex">
                <button
                  type="button"
                  :class="[
                    'rounded-md inline-flex text-primary hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-bkk-30',
                    closeButtonClass,
                  ]"
                  @click="close"
                >
                  <span class="sr-only">Close</span>
                  <XIcon class="h-5 w-5" aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { XIcon } from "@heroicons/vue/solid";

export default {
  name: "PopupNotification",
  components: {
    XIcon,
  },
  props: {
    show: Boolean,
    title: String,
    subtitle: String,
    class: String,
    closeButtonClass: String,
    closeAfter: {
      type: Number,
      default: 4500,
    },
    error: Boolean,
    autoclose: {
      default: false,
      type: Boolean,
    },
  },
  emits: ["close"],
  data() {
    return {
      open: true,
    };
  },
  watch: {
    show(newShow) {
      if (newShow) {
        this.setCloseTimeout();
      }
    },
  },
  mounted() {
    if (this.autoclose) {
      this.setCloseTimeout();
    }
  },
  methods: {
    setCloseTimeout() {
      if (this.closeAfter) {
        setTimeout(() => {
          if (this.autoclose) {
            this.open = false;
          }

          this.close();
        }, this.closeAfter);
      }
    },
    close() {
      this.$emit("close");

      if (this.autoclose) {
        this.open = false;
      }
    },
  },
};
</script>
